import { signal } from "@preact/signals-react";
import { AlertDto } from "../api/apiDtos";

export const selectedAlert = signal<AlertDto | null>(null);

export const alertActionType = signal<string | undefined>(undefined);
